const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-text">&copy;carswebsiteby@YacineAhmedAdel2023</p>
    </div>
  );
};

export default Footer;
